import Vue from 'vue';
import Router from 'vue-router';
import pcRoutes from './pc-routes.js';
import phoneRoutes from './phone-routes';
import appInnerRouter from './app-inner-router';

Vue.use(Router);

const router = new Router({
  routes: [...pcRoutes, ...phoneRoutes, ...appInnerRouter]
  // phoneRoutes
  // eslint-disable-next-line
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // }
});
router.beforeEach((to, from, next) => {
  let screenWidth = window.screen.width;
  if (to.name === 'index') {
    if (screenWidth <= 768) {
      router.push('/m-index');
    }
  }
  if (to.name === 'm-index') {
    if (screenWidth > 768) {
      router.push('/');
    }
  }
  next();
});
export default router;
